var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdFront(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 49,
    viewBox: "0 0 76 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H70C73.3137 0 76 2.68629 76 6V43C76 46.3137 73.3137 49 70 49H6C2.68629 49 0 46.3137 0 43V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 3H6C4.34315 3 3 4.34315 3 6V43C3 44.6569 4.34315 46 6 46H70C71.6569 46 73 44.6569 73 43V6C73 4.34315 71.6569 3 70 3ZM6 0C2.68629 0 0 2.68629 0 6V43C0 46.3137 2.68629 49 6 49H70C73.3137 49 76 46.3137 76 43V6C76 2.68629 73.3137 0 70 0H6Z",
    fill: "#0A395C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 24.5C38 28.5701 36.1988 32.2195 33.3501 34.6946C33.0315 34.519 32.6702 34.2969 32.2914 34.0267C31.204 33.2513 30.0449 32.1335 29.2869 30.6595C31.0694 28.5742 32.2207 25.5396 32.2207 23.1305C32.2207 19.0441 28.9081 15.7314 24.8217 15.7314C20.7353 15.7314 17.4226 19.0441 17.4226 23.1305C17.4226 25.1331 18.2182 27.5679 19.5105 29.5304C19.69 29.803 19.8791 30.0665 20.077 30.3185L19.911 30.2451C19.1683 31.9257 17.8957 33.1802 16.7086 34.0267C16.3298 34.2969 15.9685 34.519 15.6499 34.6946C12.8012 32.2195 11 28.5701 11 24.5C11 17.0442 17.0442 11 24.5 11C31.9558 11 38 17.0442 38 24.5ZM22.2323 32.3108C21.1979 34.1882 19.7331 35.5546 18.4504 36.4693C18.4221 36.4894 18.394 36.5094 18.3658 36.5291C20.2064 37.4696 22.2912 38 24.5 38C26.7088 38 28.7936 37.4696 30.6342 36.5291C30.6272 36.5242 30.6203 36.5193 30.6133 36.5144C30.5921 36.4995 30.5709 36.4845 30.5496 36.4693C29.3298 35.5995 27.9454 34.3212 26.923 32.5835C26.2569 32.9153 25.5516 33.1031 24.8217 33.1031C23.9107 33.1031 23.0383 32.8106 22.2323 32.3108ZM41 24.5C41 30.0092 38.2999 34.8878 34.1509 37.8847V38.142C34.0297 38.142 33.9176 38.1284 33.8272 38.1127C31.174 39.9341 27.9615 41 24.5 41C21.0385 41 17.826 39.9341 15.1728 38.1127C15.0824 38.1284 14.9703 38.142 14.8491 38.142V37.8847C10.7001 34.8878 8 30.0092 8 24.5C8 15.3873 15.3873 8 24.5 8C33.6127 8 41 15.3873 41 24.5ZM29.2207 23.1305C29.2207 24.4793 28.6296 26.3977 27.5676 27.97C26.4506 29.6237 25.3896 30.1031 24.8217 30.1031C24.2538 30.1031 23.1927 29.6237 22.0758 27.97C21.0138 26.3977 20.4226 24.4793 20.4226 23.1305C20.4226 20.701 22.3921 18.7314 24.8217 18.7314C27.2512 18.7314 29.2207 20.701 29.2207 23.1305Z",
    fill: "#0A395C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 8,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#0A395C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 15,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#0A395C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 22,
    width: 20,
    height: 3,
    rx: 1.5,
    fill: "#0A395C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 29,
    width: 11,
    height: 3,
    rx: 1.5,
    fill: "#0A395C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdFront);
export default __webpack_public_path__ + "static/media/idFront.6c0003857906726cd6636e11c7703fc7.svg";
export { ForwardRef as ReactComponent };